import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
import React, { useEffect, useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";

function MessageInner() {
  const { category } = useParams();
const [data, setData] = useState([]);  
  // ✅ Safe Convert "vice-principal" -> "Vice Principal"
  const formattedCategory = (category || "")
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  // ✅ Fetch and filter principal/vice principal messages
  const { data: allMessages = [] } = useQuery({
    queryKey: ["principalMessage", formattedCategory],
    queryFn: async () => {
      const res = await getPrincipalMessage();

      // ✅ Ensure we always filter an array (handles axios / wrapped responses)
      const list = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data?.result)
        ? res.data.result
        : Array.isArray(res?.result)
        ? res.result
        : [];

      return list.filter((msg) => msg?.category === formattedCategory);
    },
    enabled: !!formattedCategory,
  });

  // ✅ Update page title

  useEffect(() => {
  const fetchData = async () => {
    try {
      const msgdata = await getPrincipalMessage();

      // ✅ ensure array before filter
      const list = Array.isArray(msgdata)
        ? msgdata
        : Array.isArray(msgdata?.data)
        ? msgdata.data
        : Array.isArray(msgdata?.data?.data)
        ? msgdata.data.data
        : [];

      const data = list.filter(
        (item) => item.category === "Principal"
      );

      setData(data);
    } catch (error) {
      console.error("Error fetching principal message data:", error);
    }
  };

  fetchData();
}, []);


  useEffect(() => {
    if (!formattedCategory) return;
    document.title = `St. Joseph’s school, Barhalganj | ${formattedCategory}`;
  }, [formattedCategory]);

  // ✅ Use dummy fallback if no data
  const hasData = Array.isArray(allMessages) && allMessages.length > 0;
  const messages = hasData
    ? allMessages
    : [
        {
          name: `${formattedCategory} Name`,
          message: "<p>Coming soon...</p>",
          attachments: null,
        },
      ];

  return (
    <>
      <Breadcrumb>{formattedCategory}</Breadcrumb>

      <div className="innersec container my-5">
        <div className="row">
          <div className="col-lg-12">
            <h1>Principal's Message</h1>
          </div>

                   <div className="row">
            {data.length > 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}`}
                    className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg"
                    alt={data[0].name || "Image"}
                  />
                </LazyLoad>
                <p>
                  <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
                </p>
                <p className="name">
                  {data[0].name}
                  <span> {data[0].category} </span>
                </p>
              </div>
            )}

            {data.length === 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/topper1.jpg"
                    className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg"
                    alt=""
                  />
                </LazyLoad>

                <p className="name">
                  <span> Name </span>
                </p>
              </div>
            )}
          </div>

        </div>
      </div>
    </>
  );
}

export default MessageInner;
